import type { SVGComponentProps } from 'BreetHelpers';

export const ResolveIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='49'
		height='48'
		viewBox='0 0 49 48'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<rect
			x='0.5'
			width='48'
			height='48'
			rx='24'
			fill='#E9FBF1'
		/>
		<path
			opacity='0.4'
			d='M27.2933 17.3333H21.7066C19.2799 17.3333 17.8333 18.7799 17.8333 21.2066V26.7866C17.8333 29.2199 19.2799 30.6666 21.7066 30.6666H27.2866C29.7133 30.6666 31.1599 29.2199 31.1599 26.7933V21.2066C31.1666 18.7799 29.7199 17.3333 27.2933 17.3333Z'
			fill='#1DA654'
		/>
		<path
			d='M28.5 21.6667H20.5C20.2267 21.6667 20 21.4401 20 21.1667C20 20.8934 20.2267 20.6667 20.5 20.6667H28.5C28.7733 20.6667 29 20.8934 29 21.1667C29 21.4401 28.7733 21.6667 28.5 21.6667Z'
			fill='#1DA654'
		/>
		<path
			d='M27.1666 24.5H21.8333C21.5599 24.5 21.3333 24.2733 21.3333 24C21.3333 23.7267 21.5599 23.5 21.8333 23.5H27.1666C27.4399 23.5 27.6666 23.7267 27.6666 24C27.6666 24.2733 27.4399 24.5 27.1666 24.5Z'
			fill='#1DA654'
		/>
		<path
			d='M25.3867 27.3335H23.6067C23.3334 27.3335 23.1067 27.1068 23.1067 26.8335C23.1067 26.5602 23.3334 26.3335 23.6067 26.3335H25.3867C25.66 26.3335 25.8867 26.5602 25.8867 26.8335C25.8867 27.1068 25.6667 27.3335 25.3867 27.3335Z'
			fill='#1DA654'
		/>
	</svg>
);
